import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  postUrl() {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SETTINGS || '/admin/settings')
  },

  method() {
    return 'PATCH'
  },

  format(payload) {
    // Envoi direct du payload au backend
    return payload
  },

  parse(raw = {}, payload = {}) {
    if (!raw?.success) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'ok',
      data: {
        saved: true,
      },
    }
  },
}
